import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'
import { createSelector } from 'reselect'

export const getBedbankChangeDatesTravellers = createSelector(
  (state: App.State) => state.checkout.cart.existingOrder,
  (state: App.State) => findPostPurchaseCheckout(state.checkout.cart.mode),
  (state: App.State) => state.auth.account.email,
  (state: App.State) => state.auth.account.phone,
  (state: App.State) => state.auth.account.phonePrefix,
  (existingOrder, postPurchase, accountEmail, phone, phonePrefix) => {
    const bedbankItem = existingOrder?.bedbankItems[0]
    const tourItem = existingOrder?.tourItems[0]
    if (postPurchase === 'tour-accommodation' && tourItem) {
      const leadTraveller = tourItem.tour.travellers.find(traveller => !!traveller.isLeadPassenger) ?? tourItem.tour.travellers[0]
      return {
        bookingPhone: `+${phonePrefix}${phone}`,
        bookingEmail: accountEmail,
        guestFirstName: leadTraveller.firstName,
        guestLastName: leadTraveller.lastName,
      }
    }
    if (postPurchase === 'change-dates' && bedbankItem) {
      return {
        bookingPhone: bedbankItem.bookingPhone,
        bookingEmail: bedbankItem.bookingEmail,
        guestFirstName: bedbankItem.rooms[0]?.guestFirstName,
        guestLastName: bedbankItem.rooms[0]?.guestLastName,
      }
    }
  },
)
